import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-white">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-movie-2-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-lg font-bold text-white">一起草视频</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专为内容创作者、团队和品牌打造的视频协作平台。让创作不再孤单，让协作变得简单。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm text-white"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm text-white"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-sm text-white"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">首页</Link>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">文章中心</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">文章分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/tutorial" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">创作教程</Link>
                <Link to="/category/teamwork" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">团队协作</Link>
                <Link to="/category/tools" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">工具推荐</Link>
                <Link to="/category/case-study" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">案例分享</Link>
                <Link to="/category/industry" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">行业动态</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">联系我们</h4>
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2.5 text-sm text-foreground-400">
                  <i className="ri-mail-line text-base"></i>
                  <span>contact@spiritualhealing.cn</span>
                </div>
                <div className="flex items-center gap-2.5 text-sm text-foreground-400">
                  <i className="ri-phone-line text-base"></i>
                  <span>400-888-8888</span>
                </div>
                <div className="flex items-start gap-2.5 text-sm text-foreground-400">
                  <i className="ri-map-pin-line text-base mt-0.5"></i>
                  <span>北京市朝阳区望京科技园A座1206室</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 一起草视频. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer">Cookie 政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}